var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.893555,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#F6E003"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5003,
    cy: 40.3939,
    r: 35.8792,
    stroke: "black",
    strokeWidth: 0.658333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3037 38.7471C49.0358 38.7471 51.2248 36.5417 51.2248 33.8096C51.2248 31.0775 49.0358 28.8721 46.3037 28.8721C43.5716 28.8721 41.3662 31.0775 41.3662 33.8096C41.3662 36.5417 43.5716 38.7471 46.3037 38.7471ZM33.137 38.7471C35.8691 38.7471 38.0581 36.5417 38.0581 33.8096C38.0581 31.0775 35.8691 28.8721 33.137 28.8721C30.405 28.8721 28.1995 31.0775 28.1995 33.8096C28.1995 36.5417 30.405 38.7471 33.137 38.7471ZM33.137 42.0387C29.3023 42.0387 21.6162 43.9644 21.6162 47.7992V50.2679C21.6162 51.1731 22.3568 51.9137 23.262 51.9137H43.012C43.9173 51.9137 44.6579 51.1731 44.6579 50.2679V47.7992C44.6579 43.9644 36.9718 42.0387 33.137 42.0387ZM46.3037 42.0387C45.8264 42.0387 45.2833 42.0717 44.7073 42.121C44.7402 42.1375 44.7566 42.1704 44.7731 42.1869C46.6493 43.5529 47.9495 45.3798 47.9495 47.7992V50.2679C47.9495 50.8439 47.8343 51.4035 47.6533 51.9137H56.1787C57.0839 51.9137 57.8245 51.1731 57.8245 50.2679V47.7992C57.8245 43.9644 50.1385 42.0387 46.3037 42.0387Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.855cce5dbc4581166c9d2dfb01de002b.svg";
export { ForwardRef as ReactComponent };